//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';
import List from 'components/list/index';
import { goodsItem, videoItem, yList } from 'components/app';

export default {
  name: 'videoList',
  props: ['params'],
  metaInfo: {
    title: '视频列表'
  },
  async created () {
    console.log('----------------videoList params',this.$route.query);
  },
  data() {
    return {
      enterprise: this.params.enterpise || this.params.enterprise || G.member.enterprise,
      videoList: {
        code: undefined,
        data: {},
        msg: undefined
      },
      isLoading: false,
      list: {
        page: 1,
        items: []
      }
    };
  },
  computed: {},
  filters: {},
  components: {
    'ylp-list': List,
    yList,
    videoItem
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/videoList/page.vue